export default {
  /**
   * head 数据
   */
  // 页面标题
  title: (state) => {
    const { current, base } = state
    return {
      title: current && current.title ? `${current.title}_` : '',
      titleTemplate: `%s${base.title || ''}官方网站`,
    }
  },
  // 网页描述
  meta: (state) => {
    const { base } = state
    const { keywords, description } = base || {}
    return [
      { hid: 'keywords', name: 'keywords', content: keywords || '' },
      {
        hid: 'description',
        name: 'description',
        content: description || '',
      },
    ]
  },
  // logo
  logo: (state) => {
    const { jzyx_base_logo: logsoData = [] } = state.source
    const logo = logsoData.find((el) => el.unique_id === 'home')
    return logo && logo.image
  },
  // 系统菜单
  system: (state) => {
    const { jzyx_base_menu: menuData = [] } = state.source
    let newObj = {}
    // 格式化数据结构
    menuData.forEach((el) => {
      newObj = { ...newObj, [el.unique_id]: { name: el.title, url: el.url } }
    })
    return newObj
  },
  // 极致官方二维码
  qrc: (state) => {
    const { base } = state
    return base.image || ''
  },
  // 联系信息
  contact: (state) => {
    const { base } = state
    const { phone = '', phone_cs: phoneCs = '' } = base || {}
    return { phone, phone_cs: phoneCs }
  },
  copyright: (state) => {
    const { base } = state
    const { copyright = '', copyright_name: copyrightName = '' } = base || {}
    return `Copyright © ${copyright} All Rights Reserved. ${copyrightName} 版权所有`
  },
  // 通过路由切换检查网站置灰类型，当仅首页时，需要手动处理
  grayIndex: (state) => {
    const { gray } = state.base
    return gray === 2 || gray === 4
  },

  /**
   * 当前页面数据
   */
  current: (state) => {
    return state.current || {}
  },

  /**
   * 游戏列表数据
   */
  games: (state) => {
    return state.games || []
  },

  /**
   * 企业文化内容
   */
  cultureData: (state) => {
    const { jzyx_about_culture_next: cultureData = [] } = state.source
    return (cultureData && cultureData[0]) || {}
  },
  /**
   * 许可证列表
   */
  licenseInfo: (state) => {
    const { jzyx_base_licence: licenseData = [] } = state.source
    return licenseData || []
  },
  // 垂直堆叠式文字 Logo（白色+红色）
  logoVerticalWhiteRed: (state) => {
    const { jzyx_base_logo: logsoData = [] } = state.source
    const logo = logsoData.find((el) => el.unique_id === 'vertical-white-red')
    return logo && logo.image
  },
  // 水平连排式文字 logo（白色）
  logoHorizontalWhite: (state) => {
    const { jzyx_base_logo: logsoData = [] } = state.source
    const logo = logsoData.find((el) => el.unique_id === 'horizontal-white')
    return logo && logo.image
  },
  // 水平连排式文字 logo（白色+红色）
  logoHorizontalWhiteRed: (state) => {
    const { jzyx_base_logo: logsoData = [] } = state.source
    const logo = logsoData.find((el) => el.unique_id === 'horizontal-white-red')
    return logo && logo.image
  },
  // 底部链接列表（2025）
  footLinks: (state) => {
    const { jzyx_base_links: linksData = [] } = state.source
    if (linksData.length > 0) {
      const legalLinks = linksData.filter((el) =>
        el.unique_id.includes('footer2025-legal')
      )
      const navLinks = linksData.filter((el) =>
        el.unique_id.includes('footer2025-navs')
      )
      return { legalLinks, navLinks }
    }
    return { legalLinks: [], navLinks: [] }
  },
  // 背景视频（着陆页用）
  backgroundVideoForLanding: (state) => {
    const { jzyx_background_video: videoData = [] } = state.source
    const video = videoData.find(
      (el) => el.unique_id === 'landing-background-video'
    )
    return video || {}
  },
  // 推广视频（着陆页用）
  promoVideoForLanding: (state) => {
    const { jzyx_promo_video: videoData = [] } = state.source
    const video = videoData.find((el) => el.unique_id === 'landing-promo-video')
    return video || {}
  },
  // 着陆页游戏列表
  landingGames: (state) => {
    const { jzyx_landing_games: gamesData = [] } = state.source
    // 将 description 字段内容转为 HTML 代码
    if (gamesData.length > 0) {
      return gamesData.map((el) => ({
        ...el,
        description: el.description.replace(/\r\n/g, '<br/>'),
        links: [
          ...(el.website
            ? [{ name: '游戏官网', url: el.website, id: 'website' }]
            : []),
          ...(el.wechat
            ? [
                {
                  name: '微信公众号',
                  url: el.wechat,
                  type: 'qrc',
                  id: 'wechat',
                },
              ]
            : []),
          ...(el.taptap
            ? [{ name: 'Tap社区', url: el.taptap, id: 'taptap' }]
            : []),
          ...(el.bilibili
            ? [{ name: 'bilibili', url: el.bilibili, id: 'bilibili' }]
            : []),
        ],
      }))
    }
    return gamesData || []
  },
  // 关于极致（着陆页用）
  landingAbout: (state) => {
    const { jzyx_landing_about: aboutData = [] } = state.source
    const about = aboutData.find((el) => el.unique_id === 'landing-about')
    return (about && about.content) || ''
  },
  // 发展历程（着陆页用）
  landingTimeline: (state) => {
    const { jzyx_landing_timeline: timelineData = [] } = state.source
    return timelineData || []
  },
  // 加入极致（着陆页用）
  landingJoin: (state) => {
    const { jzyx_landing_join: jzyxLandingJoin = [] } = state.source
    const joinData = jzyxLandingJoin && jzyxLandingJoin[0]
    if (joinData) {
      const btnsMap = [
        'btn_primary_left',
        'btn_primary_right',
        'btn_bar_top',
        'btn_bar_mid',
        'btn_bar_bot',
      ]

      // 利用btnsMap生成links数组
      const links = btnsMap
        .map((btnKey) => {
          const titleKey = btnKey
          const urlKey = `${btnKey}_url`
          const descKey = `${btnKey}_desc`

          // 检查是否存在标题和链接
          if (joinData[titleKey] && joinData[urlKey]) {
            const linkData = {
              title: joinData[titleKey],
              url: joinData[urlKey],
            }

            // 如果是bar类型的按钮且有描述，则添加subtitle
            if (btnKey.includes('btn_bar') && joinData[descKey]) {
              linkData.subtitle = joinData[descKey]
            }

            return linkData
          }

          return null
        })
        .filter(Boolean) // 过滤掉null值

      return {
        title: joinData.title,
        banner: {
          landscape: joinData.image,
          portrait: joinData.image_portrait,
        },
        links,
      }
    }
    return {}
  },
}
